import React, {useEffect, useState} from 'react';
import {Link, useHistory, useParams} from "react-router-dom";
import {Select, Space} from "antd";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";

const ProfileEdit = () => {

    let history = useHistory()
    let params = useParams()
    const [sendData, setSendData] = useState({})
    const [pic, setPic] = useState(null);
    const [offices, setOffices] = useState([])
    const [officesz, setOfficesZ] = useState([])
    const [departments, setDepartments] = useState([])
    const [branch, setBranch] = useState([])
    const [roles, setRoles] = useState([])
    const bigData = new FormData()

    const [parents, setParents] = useState([])

    const getParentBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/sections/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": 			"Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setParents(res?.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }

    // const getRoles = (val) => {
    //     axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/role/get_all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
    //         .then(res => {
    //             setRoles(res.data)
    //         })
    //         .catch(err => {
    //             toast.error("Ошибка")
    //         })
    // }
    const getDeps = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/hr/department/all" + (val?.length > 0 ? "?search_str=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setDepartments(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getBuilding = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/branch/all?hierarchy=3" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getBuildingZ = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/building/all" + (val > 0 ? "&parent_id=" + val : ""), {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOfficesZ(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const getItem = () => {
        axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/user/" + params.id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setSendData(res.data)
                getDeps(res.data?.department?.department_title)
                getBuilding(res?.data?.building_id)
                // getRoles(res?.data?.role_id)
                // setSendData({...sendData, building_id: res.data.building_id})
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    // const sendAll = () => {
    //     if (pic?.target?.files[0]) {
    //         bigData.append("image", pic?.target?.files[0])
    //     }
    //     bigData.append("first_name", sendData?.first_name)
    //     bigData.append("last_name", sendData?.last_name)
    //     bigData.append("username", sendData?.username)
    //     bigData.append("email", sendData?.email)
    //     bigData.append("password", sendData?.password)
    //     bigData.append("gender", sendData?.gender)
    //     bigData.append("position", sendData?.position)
    //     bigData.append("date_of_birth", sendData?.date_of_birth)
    //     bigData.append("middle_name", sendData?.middle_name)
    //     bigData.append("phone", sendData?.phone)
    //     bigData.append("building_id", sendData?.building_id)
    //     bigData.append("branch_id", sendData?.branch_id)
    //     bigData.append("department_id", sendData?.department_id)
        // bigData.append("role_id", sendData?.role_id)





         const sendAll = () => {
    if (pic?.target?.files[0]) {
        bigData.append("image", pic?.target?.files[0])
    }
    if (sendData?.first_name) bigData.append("first_name", sendData.first_name)
    if (sendData?.last_name) bigData.append("last_name", sendData.last_name)
    if (sendData?.username) bigData.append("username", sendData.username)
    if (sendData?.email) bigData.append("email", sendData.email)
    if (sendData?.password) bigData.append("password", sendData.password)
    if (sendData?.gender) bigData.append("gender", sendData.gender)
    if (sendData?.position) bigData.append("position", sendData.position)
    if (sendData?.middle_name) bigData.append("middle_name", sendData.middle_name)
    if (sendData?.phone) bigData.append("phone", sendData.phone)

    // ID larni faqat raqam bo‘lsa yuboring
    if (sendData?.building_id && !isNaN(Number(sendData.building_id))) {
        bigData.append("building_id", Number(sendData.building_id))
    }
    if (sendData?.branch_id && !isNaN(Number(sendData.branch_id))) {
        bigData.append("branch_id", Number(sendData.branch_id))
    }
    if (sendData?.department_id && !isNaN(Number(sendData.department_id))) {
        bigData.append("department_id", Number(sendData.department_id))
    }
    // Agar role_id kerak bo‘lsa:
    // if (sendData?.role_id && !isNaN(Number(sendData.role_id))) {
    //     bigData.append("role_id", Number(sendData.role_id))
    // }

    // Sana formatini tekshirish (YYYY-MM-DD)
    if (sendData?.date_of_birth && /^\d{4}-\d{2}-\d{2}$/.test(sendData.date_of_birth)) {
        bigData.append("date_of_birth", sendData.date_of_birth)
    }

        // bigData.append("role_id", sendData?.role_id)
        axios.put(API_PATH + "user/company/" + localStorage.getItem('id') + "/update/user/" + params.id, bigData, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                // console.log(res)
                toast.success("Изменить сотрудника")
                getItem()
            })
            .catch(err => {
                console.log(err.response?.data)  
            toast.error("Ошибка при обновлении")
            })
    }
    const [photo123, setphoto123] = useState(sendData?.image);

    const uploadImg = (event) => {
        setphoto123(URL.createObjectURL(event.target.files[0]));
        setPic(event);
        setSendData({...sendData, image: event?.target?.files[0]})
    };

    const getBranch = (val) => {
        axios.get(API_PATH + "company/" + localStorage.getItem('id') + "/branch/", {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setBranch(res.data?.items)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    useEffect(() => {
        getBuildingZ()
        getBranch()
        // getRoles()
        getItem()
        getParentBuilding()
        getBuilding()
    }, []);

    return (
        <div className="profile-edit">
            <div className="progress-link">
                <Link to="/main/visitor-home" > <img src="/icon/Icon1.svg" alt="."/></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <Link to="/main/hr-admin/employees"  > <span>Cотрудники</span></Link>
                <img src="/icon/arrowleft.svg" alt="."/>
                <span>{sendData?.first_name + " " + sendData?.last_name}</span>
            </div>
            <div className="profile-header">
                <h3 className="font-family-medium">Информация о новом сотруднике</h3>
                <div className="profile-header-box-update">
                    <div className="row">
                        <div className="col-md-2 text-center">
                            {/*<img src="/img/addphoto.png" alt="."/>*/}
                            {/*<input type="file"*/}
                            {/*       onChange={(e) => setPic(e.target.files[0])}*/}
                            {/*/>*/}
                            <div className="userPhoto">
                                <label htmlFor="userPhoto" id="img1">
                                    {" "}
                                    {
                                        sendData?.image ?
                                            <img src={sendData?.image} alt=""/>
                                            :
                                            <img src={photo123} alt=""/>

                                    }
                                    <img src={photo123} alt=""/>

                                </label>
                                <input
                                    type="file"

                                    onChange={(e) => uploadImg(e)}
                                    id="userPhoto"
                                />
                                <p className="font-family-bold">Фотография</p>
                                {/*<p className="open-sans-semibold">{getText("photo")}</p>*/}
                            </div>
                        </div>
                        <div className="col-md-10">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Имя </label>
                                        <input type="text"
                                               value={sendData?.first_name ? sendData?.first_name : ""}
                                               onChange={(e) => setSendData({
                                                   ...sendData,
                                                   first_name: e.target.value
                                               })}/>
                                    </div>
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Фамилия </label>
                                        <input type="text"
                                               value={sendData?.last_name ? sendData?.last_name : ""}
                                               onChange={(e) => setSendData({...sendData, last_name: e.target.value})}/>
                                    </div>
                                    {/*<div className="inputs-box">*/}
                                    {/*    <label className="font-family-medium">Отчество </label>*/}
                                    {/*    <input type="text"*/}
                                    {/*           value={sendData?.middle_name}*/}
                                    {/*           onChange={(e) => setSendData({*/}
                                    {/*               ...sendData,*/}
                                    {/*               middle_name: e.target.value*/}
                                    {/*           })}/>*/}
                                    {/*</div>*/}
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Логин </label>
                                        <input
                                            value={sendData?.username ? sendData?.username : ""}
                                            onChange={(e) => setSendData({...sendData, username: e.target.value})}
                                            type="text"/>
                                    </div>
                                    <div className="inputs-box">
                                        <label className="font-family-medium">Парол </label>
                                        <input
                                            value={sendData?.password ? sendData?.password : ""}
                                            onChange={(e) => setSendData({...sendData, password: e.target.value})}
                                            type="text"/>
                                    </div>
                                    {/*<div className="inputs-box">*/}
                                    {/*    <label className="font-family-medium">Номер телефона </label>*/}
                                    {/*    <input*/}
                                    {/*        value={sendData?.phone}*/}
                                    {/*        onChange={(e) => setSendData({...sendData, phone: e.target.value})}*/}
                                    {/*        type="text"/>*/}
                                    {/*</div>*/}
                                    {/*<div className="inputs-box">*/}
                                    {/*    <label className="font-family-medium">Email</label>*/}
                                    {/*    <input*/}
                                    {/*        value={sendData?.email}*/}
                                    {/*        onChange={(e) => setSendData({...sendData, email: e.target.value})}*/}
                                    {/*        type="text"/>*/}
                                    {/*</div>*/}


                                    <div className="inputs-box for-select">
                                        <label className="font-family-medium">Пол </label>
                                        <FormControl>

                                            <RadioGroup
                                                row
                                                // value={sendData?.gender}
                                                value={sendData?.gender === "male" ? "male" : "female"}
                                                onChange={(e) => setSendData({...sendData, gender: e.target.value})}
                                                aria-labelledby="demo-row-radio-buttons-group-label"
                                                name="row-radio-buttons-group"
                                            >
                                                <FormControlLabel value="male" control={<Radio/>} label="Мужской"/>
                                                <FormControlLabel value="female" control={<Radio/>} label="Женский"/>
                                            </RadioGroup>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className="col-md-6">

                                    {/*<div className="inputs-box">*/}
                                    {/*    <label className="font-family-medium">Дата рождения </label>*/}
                                    {/*    <input type="date"*/}
                                    {/*           value={sendData?.date_of_birth}*/}
                                    {/*           onChange={(e) => setSendData({*/}
                                    {/*               ...sendData,*/}
                                    {/*               date_of_birth: e.target.value*/}
                                    {/*           })}*/}
                                    {/*    />*/}
                                    {/*</div>*/}

                                    <div className="inputs-box-2">
                                        <label className="font-family-medium">Раздел <button
                                            className="font-family-medium">
                                            <span
                                                className="text-white"
                                                onClick={() => history.push("/main/hierarchy/company")}>
                                                  Добавить новое
                                            </span>

                                        </button></label>
                                        <Select
                                            showSearch
                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"
                                            onSearch={getParentBuilding}
                                            onChange={(e) => getBuilding(e)}
                                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                            }
                                            options={parents?.map((item) => {
                                                return {
                                                    value: item.id,
                                                    label: item.id + " " +
                                                    item?.branch_title
                                                };
                                            })}
                                        />
                                    </div>
                                    <div className="inputs-box-2">
                                        <label className="font-family-medium">Филиал<button
                                            className="font-family-medium"
                                            >
                                            <span className="text-white"
                                                onClick={() => history.push("/main/hierarchy/company")}
                                            >
                                                 Добавить новое
                                            </span>

                                        </button></label>
                                        <Select
                                            showSearch
                                            placeholder="Выберите филиал"
                                            optionFilterProp="children"
                                            className="w-100"
                                            value={sendData?.branch_id}
                                            onSearch={getBuilding}
                                            onChange={(e) => setSendData({...sendData, branch_id: e})}
                                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                            }
                                            options={offices?.map((item) => {
                                                return {
                                                    value: item.id,
                                                    label: item.id + " " +
                                                    item?.branch_title
                                                };
                                            })}
                                        />
                                    </div>
                                    <div className="inputs-box-2">
                                        <label className="font-family-medium">Здание<button
                                            className="font-family-medium"
                                            >
                                            {/*<span*/}
                                            {/*    onClick={() => history.push("/main/hierarchy/company")}*/}
                                            {/*>*/}
                                            {/*     Добавить новое*/}
                                            {/*</span>*/}
                                        </button>
                                        </label>
                                        <Select
                                            showSearch
                                            placeholder="Выберите филиал"
                                            optionFilterProp="children"
                                            className="w-100"
                                            value={sendData?.building_id}
                                            onSearch={getBuildingZ}
                                            onChange={(e) => setSendData({...sendData, building_id: e})}
                                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                            }
                                            options={officesz?.map((item) => {
                                                return {
                                                    value: item.id,
                                                    label: item.id + " " +
                                                    item?.name
                                                };
                                            })}
                                        />
                                    </div>
                                    <div className="inputs-box-2">
                                        <label className="font-family-medium">Отдел
                                            <button
                                                className="font-family-medium text-white"
                                                onClick={() => history.push("/main/hr-admin/departments/departments-add")}>
                                                Добавить новое
                                            </button>
                                        </label>
                                        <Select
                                            showSearch
                                            placeholder="Поиск, чтобы выбрать"
                                            optionFilterProp="children"
                                            className="w-100"
                                            value={sendData?.department_id}
                                            onSearch={getDeps}
                                            onChange={(e) => setSendData({...sendData, department_id: e})}
                                            filterOption={(input, option) => (option?.label ?? '').includes(input)}
                                            filterSort={(optionA, optionB) =>
                                                (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                            }
                                            options={departments?.map((item) => {
                                                return {
                                                    value: item.id,
                                                    label: item.id + " " +
                                                    item?.department_title
                                                };
                                            })}
                                        />
                                    </div>

                                    {/*<div className="inputs-box">*/}
                                    {/*    <label className="font-family-medium">Должность </label>*/}
                                    {/*    <input type="text"*/}
                                    {/*           value={sendData?.position}*/}
                                    {/*           onChange={(e) => setSendData({...sendData, position: e.target.value})}/>*/}
                                    {/*</div>*/}
                                    {/*<div className="inputs-box-2">*/}
                                    {/*    <label className="font-family-medium">Роли*/}
                                    {/*    </label>*/}
                                    {/*    <Select*/}
                                    {/*        showSearch*/}
                                    {/*        placeholder="Поиск, чтобы выбрать"*/}
                                    {/*        optionFilterProp="children"*/}
                                    {/*        className="w-100"*/}
                                    {/*        value={sendData?.role_id}*/}
                                    {/*        onSearch={getRoles}*/}
                                    {/*        onChange={(e) => setSendData({...sendData, role_id: e})}*/}

                                    {/*        filterOption={(input, option) => (option?.label ?? '').includes(input)}*/}
                                    {/*        filterSort={(optionA, optionB) =>*/}
                                    {/*            (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())*/}
                                    {/*        }*/}
                                    {/*        options={roles?.map((item) => {*/}
                                    {/*            return {*/}
                                    {/*                value: item.id,*/}
                                    {/*                label: item.id + " " +*/}
                                    {/*                item?.name*/}
                                    {/*            };*/}
                                    {/*        })}*/}
                                    {/*    />*/}
                                    {/*</div>*/}

                                </div>

                            </div>
                            <div className="con-btn">
                                <button className="font-family-medium" onClick={sendAll}><span>Изменить</span>
                                </button>
                                <button className="font-family-medium ml-8" onClick={() => history.goBack()}>Назад</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileEdit;